import React from 'react';
import { Input } from 'antd';
import { UserOutlined, FileTextOutlined } from '@ant-design/icons';

interface InternalConsumptionStripProps {
  personName: string;
  notes: string;
  onPersonNameChange: (value: string) => void;
  onNotesChange: (value: string) => void;
  disabled?: boolean;
}

/**
 * Consumo interno (comida de personal): quién consume + motivo opcional.
 * No hay cliente ni teléfono — no es una venta.
 */
const InternalConsumptionStrip: React.FC<InternalConsumptionStripProps> = ({
  personName,
  notes,
  onPersonNameChange,
  onNotesChange,
  disabled = false,
}) => (
  <div className="ot-customer">
    <Input
      className="ot-field ot-field--name"
      prefix={<UserOutlined />}
      placeholder="Para quién (empleado) *"
      value={personName}
      onChange={(e) => onPersonNameChange(e.target.value)}
      disabled={disabled}
    />
    <Input
      className="ot-field ot-field--phone"
      prefix={<FileTextOutlined />}
      placeholder="Motivo / nota (opcional)"
      value={notes}
      onChange={(e) => onNotesChange(e.target.value)}
      disabled={disabled}
    />
  </div>
);

export default InternalConsumptionStrip;
